import LiveDataTable from '../../components/adviceStatus/LiveDataTable';
import './Live.css';

const Live = () => { 
    return (
        <>
            <div className="component_style">                
                <LiveDataTable />           
            </div>
        </>
    )
}

export default Live;